module.exports = __webpack_public_path__ + "static/media/landscapeSample.7e245fc2.mp4";